import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { track } from '../../../tracking/track';
import { events } from '../../../tracking/events';
import { getSubscriptionsURL, getPaymentsURL, getInvoicesURL } from 'growth-payments-core/urls/urls';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { NextIcon } from 'foundations-assets';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { Button } from 'foundations-components/transitional/components/Button';
import ModalWrapper from '../ModalWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TOOL_CONFIG = {
  payments: {
    modalName: 'createPayment',
    illustrationName: 'payments-button',
    url: getPaymentsURL(),
    ctaMessage: 'embedPoints.ctas.createAPaymentLink'
  },
  subscriptions: {
    modalName: 'createSubscription',
    illustrationName: 'payments-subscriptions',
    url: getSubscriptionsURL(),
    ctaMessage: 'embedPoints.ctas.createASubscription'
  },
  invoices: {
    modalName: 'createInvoice',
    illustrationName: 'invoices',
    url: getInvoicesURL(),
    ctaMessage: 'embedPoints.ctas.createAnInvoice'
  },
  setUpPayments: {
    modalName: 'setUpPayments',
    illustrationName: 'payments',
    url: getPaymentsURL(),
    ctaMessage: 'embedPoints.paymentsInterstitialModal.goToPayments'
  }
};

// UI Components
const ListItemWithIcon = ({
  children
}) => /*#__PURE__*/_jsxs(View, {
  marginBlockEnd: "300",
  children: [/*#__PURE__*/_jsx(IconCircle, {
    icon: NextIcon,
    color: "fill-accent-purple-pressed",
    size: "100",
    backgroundColor: "fill-accent-purple-subtle",
    borderColor: "fill-accent-purple-subtle",
    padding: "100",
    marginInlineEnd: "200"
  }), children]
});
const ToolModalPrimaryButton = props => /*#__PURE__*/_jsx(Button, Object.assign({
  use: "primary",
  "data-test-id": "create-tool-button"
}, props));
const CreateToolModal = ({
  onClose,
  page,
  tool
}) => {
  const trackButtonClick = useCallback(() => {
    track(events.paymentsInterstitialModalInteraction, {
      action: 'click',
      screen: page,
      value: `createTool-${tool}`
    });
  }, [page, tool]);

  // Get current tool configuration
  const config = TOOL_CONFIG[tool];
  const {
    modalName,
    illustrationName
  } = config;

  // Common button components
  const createToolButtons = {
    payments: /*#__PURE__*/_jsx(ToolModalPrimaryButton, {
      href: TOOL_CONFIG.payments.url,
      onClick: trackButtonClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: TOOL_CONFIG.payments.ctaMessage
      })
    }),
    invoices: /*#__PURE__*/_jsx(ToolModalPrimaryButton, {
      href: TOOL_CONFIG.invoices.url,
      onClick: trackButtonClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: TOOL_CONFIG.invoices.ctaMessage
      })
    }),
    subscriptions: /*#__PURE__*/_jsx(ToolModalPrimaryButton, {
      href: TOOL_CONFIG.subscriptions.url,
      onClick: trackButtonClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: TOOL_CONFIG.subscriptions.ctaMessage
      })
    }),
    setUpPayments: /*#__PURE__*/_jsx(ToolModalPrimaryButton, {
      href: TOOL_CONFIG.setUpPayments.url,
      onClick: trackButtonClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: TOOL_CONFIG.setUpPayments.ctaMessage
      })
    })
  };

  // Dropdown component
  const ToolSelectionDropdown = props => /*#__PURE__*/_jsx(Dropdown, Object.assign({
    "data-test-id": "tool-selection-dropdown",
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.ctas.collectPaymentsWithTools"
    }),
    placement: "bottom"
  }, props, {
    children: /*#__PURE__*/_jsxs(List, {
      children: [/*#__PURE__*/_jsx(ListItem, {
        children: createToolButtons.payments
      }), /*#__PURE__*/_jsx(ListItem, {
        children: createToolButtons.invoices
      }), /*#__PURE__*/_jsx(ListItem, {
        children: createToolButtons.subscriptions
      })]
    })
  }));

  // Determine primary and secondary CTAs based on tool type
  const primaryCTA = tool === 'payments' ? /*#__PURE__*/_jsx(ToolSelectionDropdown, {
    buttonUse: "primary"
  }) : createToolButtons[tool];
  const secondaryCTA = tool === 'setUpPayments' ? /*#__PURE__*/_jsx(ToolSelectionDropdown, {}) : null;

  // Modal content
  const Body = /*#__PURE__*/_jsx(List, {
    marginBlockStart: "300",
    children: [1, 2, 3].map(num => /*#__PURE__*/_jsx(ListItemWithIcon, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `embedPoints.setUpPayments.p${num}`
      })
    }, num))
  });
  const Footer = /*#__PURE__*/_jsxs(_Fragment, {
    children: [primaryCTA, secondaryCTA]
  });
  const modalSubTitle = /*#__PURE__*/_jsx(Text, {
    as: "h4",
    textAlign: "left",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `embedPoints.${modalName}.subTitle`
    })
  });
  return /*#__PURE__*/_jsx(ModalWrapper, {
    onClose: onClose,
    modalName: modalName,
    modalSubTitle: modalSubTitle,
    Body: Body,
    Footer: Footer,
    illustrationName: illustrationName,
    contentClassName: "p-top-15 p-bottom-5 p-right-10"
  });
};
export default CreateToolModal;